export enum TickerSymbolStatus {
  HALTED = 'halted',
  INVALID = 'invalid',
  QUOTE_ERROR = 'quoteError',
  UNSIGNED_AGREEMENT = 'unsignedAgreement'
}
